import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const DeleteTemplateConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  isLoading,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="delete-template-modal-wrapper"
    >
      <Modal.Body className="pt-0 pb-2">
        <Modal.Header className="modal-title-with-border mb-0" closeButton>
          <Modal.Title>Delete Section Template?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="delete-confirmation-modal-body">
          <div className="mb-3">
            <ul>
              <li>This action cannot be undone.</li>
              <li>Make sure you no longer need this Section Template.</li>
              <li>
                Deleting a Section Template won't affect your existing projects
                or reports.
              </li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer className="mt-0">
          <Button
            variant="outline-secondary"
            onClick={onHide}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteTemplateConfirmationModal;
